import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { store, history } from "./store";
import "ui-assets";
import LayoutContainer from "containers/LayoutContainer";
import { EndSessionRequest } from "@azure/msal-browser";
import { Router, Switch } from "react-router";
import { toast, ToastContainer } from "react-toastify";
import AuthRoute from "./components/common/PrivateRoute";
import Localization from "react-widgets/Localization";
import { DateLocalizer } from "react-widgets/IntlLocalizer";
import { useMsal } from '@azure/msal-react';

import config from "./config";

const dateLocalizer = new DateLocalizer({ culture: "en-US" });

toast.configure();

const logoutRequest: EndSessionRequest = {
    postLogoutRedirectUri: config.msal.postLogoutRedirectUri,
};

//avoid extra rerender children components
const SingOutWrapper: React.FC<{ children: (signOut: () => void) => React.ReactNode; }> = ({ children }) => {
    const { instance } = useMsal();

    const signOut = () => {
        localStorage.removeItem("token");
        instance.logout(logoutRequest);
    };

    return <>{children(signOut)}</>;
};

export default () => (
    <Provider store={store}>
        <Localization date={dateLocalizer}>
            <Router history={history}>
                <Suspense fallback={<div>Loading...</div>}>
                    <Switch>
                        <AuthRoute
                            path="/"
                            component={() => (
                                <SingOutWrapper>
                                    {(signOut) => <LayoutContainer signOut={signOut} />}
                                </SingOutWrapper>
                            )}
                        />
                    </Switch>

                    <ToastContainer enableMultiContainer containerId={"A"} position={toast.POSITION.BOTTOM_CENTER} />
                </Suspense>
            </Router>
        </Localization>
    </Provider>
);
